import { createFileRoute } from '@tanstack/react-router';

import { AdminKanban } from '@/pages/admin/kanban/AdminKanban';

export const Route = createFileRoute('/admin/_admin/kanban')({
  component: AdminKanban
});
